// @ts-nocheck

  import UserOutlined from '@ant-design/icons/es/icons/UserOutlined';
import SmileOutlined from '@ant-design/icons/es/icons/SmileOutlined'
  export default {
    UserOutlined,
SmileOutlined
  }